import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import { ResponseListing360, ResponseEmpData, ResponseSubmit, ResponseListingQuestion } from "../../../shared/nestjs/gd-integrated/dto/question360.dto";
import { Question360Api } from "../../../shared/nestjs/gd-integrated/services/question360.api";


@Injectable()
export class Question360Bloc {

  constructor(
    public question360Api: Question360Api,
  ) {
  }

  history(empId: string, page: number, limit: number): Observable<ResponseListing360> {
    console.log('BLOC listing', empId, page, limit)
		return this.question360Api.history(empId, page, limit);
  }

  empData(empId: string): Observable<ResponseEmpData> {
		return this.question360Api.empData(empId);
  }

  formHeader(revieweeEmpid: string, periodcode: string): Observable<ResponseEmpData> {
		return this.question360Api.formHeader(revieweeEmpid, periodcode);
  }

  formQuestion(revieweeEmpid: string, periodcode: string, page: number, limit: number): Observable<ResponseListingQuestion> {
		return this.question360Api.formQuestion(revieweeEmpid, periodcode, page, limit);
  }

  submit(data): Observable<ResponseSubmit> {
		return this.question360Api.submit(data);
  }
  
}



// WEBPACK FOOTER //
// ./src/bloc/hr/performance-sf6/question360.bloc.ts